import { Controller } from "@hotwired/stimulus"

// Kiosk search box: shows the on-screen keyboard on focus and refreshes the
// results frame shortly after typing stops.
export default class extends Controller {
  static targets = ["form", "keyboard"]

  showKeyboard() {
    this.keyboardTarget.hidden = false
  }

  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.formTarget.requestSubmit(), 300)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
